module.exports = new __parcel__URL__("venkatesh.1cb5c178.png").toString();